export default "__VITE_ASSET__CZxC8u0e__"